<template>
  <title>Close</title>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.58599 7.00001L0.635985 2.05001L2.04999 0.636011L6.99999 5.58601L11.95 0.63601L13.364 2.05001L8.41399 7.00001L13.364 11.95L11.95 13.364L6.99999 8.41401L2.04999 13.364L0.635986 11.95L5.58599 7.00001Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps({
  fill: {
    type: String,
    default: 'white'
  }
})
</script>
